(function () {
  function setupMegaMenu(nav) {
    if (!nav || nav.dataset.rkpMegaReady === 'true') return;
    nav.dataset.rkpMegaReady = 'true';

    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-rkp-mega-item]'));
    var desktopQuery = window.matchMedia('(min-width: 990px)');
    var closeTimers = new WeakMap();

    function closeItem(item) {
      if (!item) return;
      item.removeAttribute('open');
    }

    function closeOthers(active) {
      items.forEach(function (item) {
        if (item !== active) closeItem(item);
      });
    }

    function openItem(item) {
      if (!item || !desktopQuery.matches) return;
      closeOthers(item);
      item.setAttribute('open', '');
    }

    function scheduleClose(item) {
      if (!item || !desktopQuery.matches) return;
      window.clearTimeout(closeTimers.get(item));
      var timer = window.setTimeout(function () {
        if (!item.matches(':hover') && !item.contains(document.activeElement)) {
          closeItem(item);
        }
      }, 160);
      closeTimers.set(item, timer);
    }

    items.forEach(function (item) {
      var summary = item.querySelector('summary');
      if (!summary) return;

      item.addEventListener('mouseenter', function () { openItem(item); });
      item.addEventListener('mouseleave', function () { scheduleClose(item); });
      item.addEventListener('focusin', function () { openItem(item); });
      item.addEventListener('focusout', function () { scheduleClose(item); });

      summary.addEventListener('click', function (event) {
        if (!desktopQuery.matches) return;
        event.preventDefault();
        if (item.hasAttribute('open')) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!nav.contains(event.target)) closeOthers(null);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeOthers(null);
        var focused = document.activeElement;
        if (focused && nav.contains(focused)) focused.blur();
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-rkp-mega]').forEach(setupMegaMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
